import {Modal} from 'rimble-ui'
import closeIcon from '../assets/new-ui/close-icon.svg'

export default function ModalVideo(props) {
  const {toggleModal, setToggleModal} = props

  return (
    <>
      <Modal isOpen={toggleModal} className='modalVideo'>
        <div className='videoBox'>
          <img src={closeIcon} alt='close icon' onClick={() => setToggleModal(false)} />
          <iframe 
            title="intro"
            allow="fullscreen"
            className='videoFrame'
            src="https://www.youtube.com/embed/a2ha03BkVxQ?mute=1&autoplay=1">
          </iframe>
        </div>
        
      </Modal>
    </>
  )
}